import { useEffect, useRef } from "react";

/** Leaving an operation discards its draft; review/back within it keeps it. */
export function useWalletFormReset(
  visible: boolean,
  tab: string,
  reset: () => void,
) {
  const previous = useRef({ visible, tab });
  const resetRef = useRef(reset);
  resetRef.current = reset;
  useEffect(() => {
    const before = previous.current;
    previous.current = { visible, tab };
    if (before.visible && (!visible || before.tab !== tab)) resetRef.current();
  }, [visible, tab]);
}
